import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { api } from '../api/client';
import { activeProject } from '../stores/project.store';
import { SkeletonBar } from '../components/ui';
import { T } from '../styles/tokens';

export function CategoryPage({ slug }: { slug?: string; path?: string }) {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    const projectId = activeProject.value?.id;
    const qs = projectId ? `?project_id=${projectId}` : '';
    
    api.get<any>(`/categories/${slug}/actions${qs}`)
      .then((res: any) => {
        setData(res);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [slug, activeProject.value?.id]);

  if (loading) return (<div style={{ padding: 20 }}><SkeletonBar width="40%" height={20} style={{ marginBottom: 16 }} /><SkeletonBar width="100%" height={14} style={{ marginBottom: 8 }} /><SkeletonBar width="70%" height={14} /></div>);
  if (!data) return <div class="page-empty">Categoria não encontrada</div>;

  const { category, groups, total } = data;

  return (
    <div>
      <div class="page-header">
        <h1>{category.icon} {category.name}</h1>
        <span style={{ fontSize: 13, color: T.textMuted }}>
          {total} {total === 1 ? 'ação disponível' : 'ações disponíveis'}
        </span>
      </div>

      {groups.length === 0 ? (
        <div class="card" style={{ textAlign: 'center', padding: 40 }}>
          <p style={{ fontSize: 16, color: T.textMuted }}>
            Nenhuma ação disponível nesta categoria.
          </p>
          <p style={{ fontSize: 13, color: T.textMuted, marginTop: 8 }}>
            O administrador pode criar ações no painel Admin → Actions.
          </p>
        </div>
      ) : (
        <div class="shortcut-grid" style={{ gridTemplateColumns: '1fr' }}>
          {groups.flatMap((group: any) =>
            group.actions.map((action: any) => (
              <ActionCard key={action.id} action={{ ...action, agent_name: group.agent.name }} />
            ))
          )}
        </div>
      )}
    </div>
  );
}

function ActionCard({ action }: { action: any }) {
  const agentName = action.agent_name || '';

  return (
    <div
      class="shortcut-card"
      onClick={() => route(`/actions/${action.id}`)}
    >
 <div class="shortcut-icon">{action.icon || ''}</div>
      <div class="shortcut-info">
        <div class="shortcut-name">{action.name}</div>
        {agentName && <div class="shortcut-meta">{agentName}</div>}
      </div>
    </div>
  );
}
